<script>
    import { checkPWA } from '../../../store';

    import Icon from '../../atoms/Icon.svelte';
    import safari from '../../../../public/assets/svg/24/safari.svg';
    import share from '../../../../public/assets/svg/24/share.svg';
    import options from '../../../../public/assets/svg/24/options.svg';
    import homescreen from '../../../../public/assets/svg/24/homescreen.svg';

    function triggerBeforeInstallPrompt() {
        // Show the prompt
        $checkPWA.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        $checkPWA.deferredPrompt.userChoice
        .then((choiceResult) => {
            if (choiceResult.outcome === undefined) {
                console.log('User accepted the A2HS prompt');
            } else {
                console.log('User dismissed the A2HS prompt');
            }
            $checkPWA.deferredPrompt = null;
        });
    }

    function useinBrowser() {
        $checkPWA.instructionsToShow = null;
    }

    // This was an attempt to toggle the share modal on click. 
    // iOS is not showing the "add to homescreen" option in this case.
    // We have to wait for beforeinstallPrompt on iOS and show regular instructions till then
    
    /* function webShare() {
        if(navigator.share) {
            navigator.share({
                title: 'Originea',
                url: 'https://originea.xyz'
            })
            .then(() => {console.log('Scuessful sharing.')})
            .catch(() => {console.log('Error sharing.', error)})
        }
    }
    */
</script>

<style>
    .instructions {
        display: flex;
        flex-direction: column;
        padding: 0 1.5rem;
        height: 100%;
    }
    .instructions__header {
        margin: 2rem auto;
    }
    /* .instructions__image {
        margin-top: auto;
    } */
    .instructions__list {
        list-style: none;
        padding: 0;
    }
    .instructions__list li {
        display: flex;
        align-items: center;
        margin: 2rem 0;
    }
    .instructions__list span {
        margin-left: 1rem;
    }
    .instructions__passwithout {
        display: flex;
        font-size: 0.875em;
        text-decoration: underline;
        margin: auto 0 4rem 0;
    }
</style>

<div class="instructions">
    <img class="instructions__header" width="94" src="./assets/svg/logo_text.svg" alt="Originea">
    <h1 class="instructions__lead">Launch Originea from your home screen.</h1>
    {#if $checkPWA.instructionsToShow}
        {#if $checkPWA.instructionsToShow === 'installPrompt'}
            <div class="btn__group instructions__buttons">
                <button class="btn btn--primary" on:click={triggerBeforeInstallPrompt}>
                    Add to homescreen
                </button>
            </div>
        {:else if $checkPWA.instructionsToShow !== null}
            <ul class="instructions__list">
                {#if $checkPWA.instructionsToShow === 'iOSWebView' || $checkPWA.instructionsToShow === 'iOSBrowserTab'}
                    <li>
                        <Icon data={safari} stroke="none" ></Icon>
                        <span>1. Open in Safari</span>
                    </li>
                    <li>
                        <Icon data={share} stroke="none" ></Icon>
                        <span>2. Tab on share</span>
                    </li>
                    <li>
                        <Icon data={homescreen} stroke="none" ></Icon>
                        <span>3. Add to home screen</span>
                    </li>    
                {:else}
                    {#if $checkPWA.instructionsToShow === 'AndroidWebView'}
                        <li>
                            <Icon data={safari} stroke="none" ></Icon>
                            <span>Open in Browser</span>
                        </li>
                    {/if}
                    <li>
                        <Icon data={options} stroke="none" ></Icon>
                        <span>Tab on options</span>
                    </li>
                    <li>
                        <Icon data={homescreen} stroke="none" ></Icon>
                        <span>Install or "Add to home screen"</span>
                    </li>
                {/if}
            </ul>
            <button class="instructions__passwithout" on:click={useinBrowser}>Continue without adding</button>
        {/if}
    {:else}
        <p class="messages">Loading...</p>
    {/if}
</div>